import React from 'react';
import { Modal, ModalBody, ModalFooter } from 'reactstrap';
import './styles.scss';
import PrivacyInfo from "../../PrivacyInfo/PrivacyInfo";

class PrivacyModal extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      modal: false
    };

    this.toggle = this.toggle.bind(this);
  }

  toggle() {
    this.setState({
      modal: !this.state.modal
    });
  }

  render() {
    const { buttonLabel, className } = this.props;
    const { modal } = this.state;
    return (
      <React.Fragment>
        <a className="dropdown-menu-link" onClick={this.toggle}>
          {buttonLabel}
        </a>
        <Modal
          isOpen={modal}
          toggle={this.toggle}
          className={className}
          size="lg"
        >
          <ModalBody className="privacy-modal-body">
            <PrivacyInfo toggleModal={this.toggle} showClose={true}/>
          </ModalBody>
        </Modal>
      </React.Fragment>
    );
  }
}

export default PrivacyModal;



// WEBPACK FOOTER //
// ./src/components/modals/PrivacyModal/PrivacyModal.jsx